(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["precious-campaign"] && !Shopify.designMode) return;
  try {
    
  function initializePreciousCampaign() {
    document.querySelectorAll('[data-precious-campaign]').forEach((root) => {
      const video = root.querySelector('[data-launch-video] video');
      const hold = root.querySelector('[data-video-hold]');
      const button = root.querySelector('.pl-video-toggle');
      if (!video || !button || button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.hidden = false;
      video.loop = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      let completedPlays = 0;
      let settled = false;
      let userPaused = false;
      let hasMotion = false;
      let previousTime = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayAllowed = () => !reducedMotion.matches && !navigator.connection?.saveData;
      const update = () => {
        const moving = hasMotion && !video.paused && !settled;
        button.textContent = settled ? button.dataset.replayLabel : moving ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.setAttribute('aria-pressed', String(moving));
      };
      const settle = () => {
        settled = true;
        hasMotion = false;
        video.autoplay = false;
        video.pause();
        if (hold) hold.hidden = false;
        root.dataset.videoState = 'settled';
        update();
      };
      const play = () => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'auto';
        root.dataset.videoState = 'loading';
        const request = video.play();
        if (request) request.catch(() => {
          if (settled) return;
          hasMotion = false;
          root.dataset.videoState = 'blocked';
          update();
        });
        update();
      };
      const retryAutoplay = () => {
        if (!settled && !userPaused && !hasMotion && autoplayAllowed() && !document.hidden) play();
      };
      video.addEventListener('timeupdate', () => {
        if (!settled && !video.paused && video.currentTime > previousTime + 0.01) {
          hasMotion = true;
          root.dataset.videoState = 'playing';
        }
        previousTime = video.currentTime;
        update();
      });
      video.addEventListener('pause', () => {
        hasMotion = false;
        if (!settled) root.dataset.videoState = 'paused';
        update();
      });
      video.addEventListener('waiting', () => {
        hasMotion = false;
        update();
      });
      video.addEventListener('loadeddata', retryAutoplay);
      video.addEventListener('canplay', retryAutoplay);
      video.addEventListener('ended', () => {
        completedPlays += 1;
        root.dataset.completedPlays = String(completedPlays);
        hasMotion = false;
        if (completedPlays >= 2) settle();
        else {
          previousTime = 0;
          video.currentTime = 0;
          play();
        }
      });
      button.addEventListener('click', () => {
        if (settled) {
          settled = false;
          completedPlays = 0;
          root.dataset.completedPlays = '0';
          previousTime = 0;
          if (hold) hold.hidden = true;
          video.currentTime = 0;
          userPaused = false;
          play();
        } else if (video.paused || !hasMotion) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          video.pause();
        }
      });
      document.addEventListener('visibilitychange', retryAutoplay);
      window.addEventListener('pageshow', retryAutoplay);
      reducedMotion.addEventListener('change', (event) => {
        if (event.matches) settle();
      });
      if (autoplayAllowed()) {
        video.autoplay = true;
        video.preload = 'auto';
        if (video.readyState === 0) video.load();
        play();
      } else settle();
      update();
    });
  }
  initializePreciousCampaign();
  document.addEventListener('shopify:section:load', initializePreciousCampaign);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["precious-coming-soon"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pc-password').forEach(function (details) {
    if (details.querySelector('.pc-error')) details.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
